import React, { createContext, useContext, ReactNode } from "react";
import useNoticeType from "@root/hooks/useNoticeType";

const defaultState: allAnyTypes = {
  noticeTypeLoading: false,
  addNoticeTypeLoading: false,
  deleteNoticeTypeLoading: false,
  updateNoticeTypeLoading: false,
  noticeTypeData: [],
  pageNo: 1,
  setPageNo: () => {},
  pageCount: 1,
  pageSize: 10,
  setPageCount: () => {},
  fetchNoticeType: () => {},
  addNoticeType: () => {},
  updateNoticeType: () => {},
  deleteNoticeType: () => {},
};
const NoticeTypeContext = createContext<any>(defaultState);

interface NoticeTypeProviderProps {
  children: ReactNode;
}

export const NoticeTypeProvider: React.FC<NoticeTypeProviderProps> = ({
  children,
}) => {
  const data = useNoticeType();
  return (
    <NoticeTypeContext.Provider value={data}>
      {children}
    </NoticeTypeContext.Provider>
  );
};

export const useNoticeTypeContext = () => {
  return useContext(NoticeTypeContext);
};
